/** Big move: the world dims and the caster alone stays lit, with their effects on top. */
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'cinematicDim',
  layer: 'world',
  order: 100,
  draw(f) {
    if (!(f.cine > 0.01)) return;
    f.g.fillStyle = `rgba(6,4,12,${0.5 * f.cine})`;
    f.g.fillRect(0, 0, f.W, f.H);
    const hero = f.world.get(f.effects.cineSrc);
    if (hero) f.drawEntity(hero);
  },
});
